import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/268V-logo.png'
import _imports_1 from '../../../assets/image/icon_service.png'
import _imports_2 from '../../../assets/image/iconRight.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-6f719f54")

_pushScopeId("data-v-6f719f54")
const _hoisted_1 = { class: "ui__reportResult_main" }
const _hoisted_2 = { class: "ui__reportResult_title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__reportResult_title_left" }, "验货结论", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("验货结果由")
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("提供")
const _hoisted_7 = { class: "ui__reportResult_content" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "ui__reportResult_content_title" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__reportResult_content_top" }, "已通过检测"),
  /*#__PURE__*/_createVNode("div", { class: "ui__reportResult_content_bottom" }, "经检测此车通过268V实车检测，非重大事故车、非火烧车、非泡水车")
], -1)
const _hoisted_9 = { class: "ui__reportResult_content_img" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  class: "icon_service"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 本宝贝由268V提供90天内错检回购服务 ")
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "",
  class: "icon_right"
}, null, -1)
const _hoisted_13 = { class: "ui__comTitle_model" }
const _hoisted_14 = { class: "ui__comTitle_model_title" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 90天内错检回购服务 ")
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_model_cnt" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_model_box" }, " 通过268V实车检测的车辆，检测保障激活后，自承保激活日起90天内，若您发现被检测车辆为重大事故、火烧、泡水车而检报告未准确反映的，268V负责对该车辆进行差价赔付或按交易价回购。 "),
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_model_box" }, "检报告激活方式"),
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_model_box" }, [
    /*#__PURE__*/_createTextVNode(" ① 微信搜索“268V车况检测专家”小程序；"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" ② 点击【激活保障】，进入激活页面"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" ③ 填写成交信息及上传交易凭证，即可激活90天回购保障说明：请在车辆完成交易及过户后再激活保障。 ")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        class: "ui__reportResult_title_right",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goIntroduce && _ctx.goIntroduce(...args)))
      }, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode("div", _hoisted_9, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.photoList.slice(0,4), (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "ui__reportResult_content_img_item",
            key: item.photoIdStr
          }, [
            (index < 3)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: item.smallPhotoUrl ? item.smallPhotoUrl : item.photoPath,
                  onClick: ($event: any) => (_ctx.goPhoto(item))
                }, null, 8, ["src", "onClick"]))
              : _createCommentVNode("", true),
            (index === 3)
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("img", {
                    src: item.smallPhotoUrl
                  }, null, 8, ["src"]),
                  _createVNode("div", {
                    class: "ui__reportResult_content_img_item_cover",
                    onClick: ($event: any) => (_ctx.goPhoto(item, 'total'))
                  }, [
                    _createVNode("h6", null, _toDisplayString(_ctx.state.photoLength) + "张", 1)
                  ], 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", {
      class: "ui__ReportResult_service",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showModel && _ctx.showModel(...args)))
    }, [
      _hoisted_10,
      _hoisted_11,
      _hoisted_12
    ]),
    _withDirectives(_createVNode("div", {
      class: "ui__comTitle_model_cover",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
    }, null, 512), [
      [_vShow, _ctx.state.isShowModel]
    ]),
    _withDirectives(_createVNode("div", _hoisted_13, [
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode("img", {
          src: require('../../../assets/image/close-icon.png'),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
        }, null, 8, ["src"])
      ]),
      _hoisted_16
    ], 512), [
      [_vShow, _ctx.state.isShowModel]
    ])
  ]))
})